export function normalizePhone(raw) {
  if (!raw) return "";
  return [...String(raw)].filter((ch) => /\d/.test(ch) || ch === "+").join("");
}

export const CONTACT_PHONE_HOST_HINT =
  "WhatsApp number for the host — only they can see it to message you.";
